/*
------------------------------------------------
Delishop Framework
Guarantees Delishop
Version: 1.0
Compatible: Shrine Pro 1.5.4
------------------------------------------------
*/

(function () {

    function initGuarantees(section) {

        if (!section) return;

        // Espacio reservado para futuras mejoras.
        // Actualmente la sección es completamente estática.

    }

    document.addEventListener("DOMContentLoaded", function () {

        document
            .querySelectorAll(".dh-guarantees")
            .forEach(initGuarantees);

    });

    document.addEventListener("shopify:section:load", function (event) {

        const section = event.target.querySelector(".dh-guarantees");

        if (section) {

            initGuarantees(section);

        }

    });

})();